import { render, staticRenderFns } from "./mainComponent.vue?vue&type=template&id=6170190d&scoped=true&"
import script from "./mainComponent.vue?vue&type=script&lang=js&"
export * from "./mainComponent.vue?vue&type=script&lang=js&"
import style0 from "./mainComponent.vue?vue&type=style&index=0&id=6170190d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170190d",
  null
  
)

export default component.exports